<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<form [formGroup]="form">
	<ng-container *ngIf="!visible; else showNumber">
		<p>
			{{ locale.translations['user']['user-verify']['n233'] }}
			<br />

			<span dir="ltr">{{ auth.user()['phone'] }}</span>
		</p>

		<p>
			{{ locale.translations['user']['user-verify']['n234'] }}
		</p>

		<div class="mdc-layout-grid__inner">
			<div class="mdc-layout-grid__cell--span-12">
				<mat-form-field appearance="standard" hideRequiredMarker>
					<mat-label>{{ locale.translations['user']['user-verify']['n235'] }}</mat-label>

					<input matInput required minlength="6" maxlength="6" (keypress)="isNumberKey($event)" formControlName="otp" id="otp" />
				</mat-form-field>

				<span style="height: 1em">
					<a [routerLink]="['.']" (click)="resendOTP()" *ngIf="showResendOTP">
						{{ locale.translations['user']['user-verify']['n236'] }}
					</a>

					<span *ngIf="!showResendOTP" class="showResendOTPTimer">
						<div class="spinner preserve">
							<mat-progress-spinner mode="determinate" [value]="(showResendOTPTimer / 30) * 100" diameter="20"></mat-progress-spinner>
						</div>

						<span>{{ showResendOTPTimer }}</span>
					</span>
				</span>

				<span style="height: 1em; display: block">
					<a [routerLink]="['.']" (click)="onToggle()" *ngIf="showphone">
						{{ locale.translations['user']['user-profile']['n244'] }}
					</a>
				</span>
			</div>

			<div class="mdc-layout-grid__cell--span-12">
				<button
					class="btn btn-default"
					mat-flat-button
					color="primary"
					(click)="checkOtp()"
					[disabled]="loading || form.get('otp').invalid || invalidPhone"
				>
					{{ locale.translations['logup']['n287'] }}
				</button>
			</div>

			<div class="mdc-layout-grid__cell--span-12 text-center text-md-left">
				<span>{{ this.locale.translations['misc']['n174'] }}</span>

				<a class="logout-btn" (click)="onLogout()">{{ locale.translations['header']['n9'] }}</a>
			</div>
		</div>

		<div id="sign-in-button"></div>
	</ng-container>

	<ng-template #showNumber>
		<p>
			{{ locale.translations['user']['user-process']['n243'] }}
		</p>

		<div class="mdc-layout-grid__inner">
			<div class="mdc-layout-grid__cell--span-12">
				<div class="container" fxLayout="row" fxLayout.xs="row" fxLayoutWrap>
					<mat-form-field fxFlex="10" appearance="standard" hideRequiredMarker>
						<mat-label></mat-label>
						<mat-select formControlName="phonePrefix">
							<mat-select-trigger>
								<span>{{ form.controls.phonePrefix.value }}</span>
							</mat-select-trigger>

							<input class="search_feild" placeholder="Search" (keyup)="onKey($event.target.value)" required />

							<mat-option *ngFor="let prefix of filterselectedCountryPrefix" (click)="onSelect(prefix.dial_code)" [value]="prefix.dial_code">
								{{ prefix.flag }} {{ prefix.name }} ({{ prefix.dial_code }})
							</mat-option>
						</mat-select>
					</mat-form-field>

					<mat-form-field class="phone_wrap" fxFlex="90" appearance="standard" hideRequiredMarker>
						<mat-label>{{ locale.translations['logup']['login']['n229'] }}</mat-label>

						<input
							#PhoneInput
							matInput
							required
							dir="ltr"
							type="tel"
							pattern="[0-9]{0,}"
							(keyup)="onPhoneKeyUp()"
							(keypress)="isNumberKey($event)"
							(focus)="PhoneInput.setSelectionRange(PhoneInput.value.length, PhoneInput.value.length)"
							[ngStyle]="{ 'text-align': locale.lang === 'en' ? 'left' : 'right' }"
							formControlName="phoneNumber"
						/>
						<mat-hint *ngIf="!validMobile">{{ locale.translations['logup']['signup']['n231'] }}</mat-hint>

						<mat-error *ngIf="!form.get('phoneNumber').valid">
							{{ locale.translations['logup']['signup']['n231'] }}
						</mat-error>
					</mat-form-field>
				</div>

				<div class="container">
					<button
						fxflex="100"
						class="btn btn-default phone-change"
						mat-flat-button
						color="primary"
						(click)="changePhone()"
						[disabled]="loading || this.form.controls['phoneNumber'].value.length == '1'"
					>
						{{ locale.translations['logup']['n287'] }}
					</button>
				</div>
			</div>
		</div>
	</ng-template>
</form>
